(function ($, Cobalt, undefined) {
    Cobalt.ModelMultiSymbolField = function ($field) {
        var that = this;
        this.field = $field;
        this.delimiter = this.field.attr("data-delimiter");

        this.symbolsID = that.field.attr("id");
        this.previousSymbol = $('#' + this.symbolsID + '-previous');
        this.symbol = $('#' + this.symbolsID + '-symbol');

        this.newField = $("<input>")
                            .attr("type", "text")
                            .attr("name", "newmmsfield")
                            .attr("data-symbol-id", this.field.attr("id"))
                            .attr("data-each-validation-length-message", this.field.attr("data-each-validation-length-message"))
                            .attr("data-each-validation-length", this.field.attr("data-each-validation-length"));

        this.autoCompleteMenu = null;
        this.hasAutoComplete = false;
        this.addCurrentModels = function () {
            var fieldVal = that.field.val();
            var symbolVal = that.symbol.val();
            var fieldValues = fieldVal.split(that.delimiter);
            var symbolValues = symbolVal.split(that.delimiter);
            $(fieldValues).each(function (i, val) {
                if (val != "") {
                    that.addFieldValue(val, symbolValues[i].trim());
                }
            });
        };

        this.appendFieldValue = function (text, id) {
            that.newField.val("");
            if (that.autoCompleteMenu != null) {
                $(".modal.tag-autocomplete").hide();
                that.hasAutoComplete = false;
            }
            if (text == "") {
                return;
            }
            if (this.symbol.val().length > 0) {
                var valsArr = this.field.val().split(this.delimiter);
                for (var i = 0; i < valsArr.length; i++) {
                    if (valsArr[i] == id) {
                        return;
                    }
                }
                this.symbol.val(this.symbol.val() + this.delimiter + id);
                this.previousSymbol.val(this.previousSymbol.val() + this.delimiter + text);
            }
            else {
                this.symbol.val(id);
                this.previousSymbol.val(text);
            }
            this.field.val(this.symbol.val());
            this.addFieldValue(text, id);
        };

        this.addFieldValue = function (text, id) {
            var modelElem = that.newField.parent().find(".tags-cloud");
            if (modelElem.length <= 0) {
                modelElem = $("<ul>").addClass("flat-list").addClass("tags-cloud");
                var modelContainer = $("<div>").addClass("tag-cloud").append(modelElem);
                $(that.newField).parent().append(modelContainer);
            }
            var modelRemove = $("<a>").attr("href", "#").addClass("tag-remove").text("remove");
            var modelSpan = $("<span>").addClass("tag-text").attr("data-id", id).html(text);
            var modelItem = $("<li>").addClass("tag");
            modelItem.append(modelRemove).append(modelSpan);
            modelRemove.click(function (event) {
                var currentFieldsVal = that.symbol.val();
                var valsArr = currentFieldsVal.split(that.delimiter);
                var newValsArr = new Array();
                var modelID = $(this).siblings(".tag-text").attr("data-id");
                for (var i = 0; i < valsArr.length; i++) {
                    if (valsArr[i].trim() != modelID) {
                        newValsArr.push(valsArr[i].trim());
                    }
                }

                that.symbol.val(newValsArr.join(that.delimiter));
                that.field.val(newValsArr.join(that.delimiter));
                if (that.field.val() == '') {
                    modelItem.parent().remove();
                }
                else {
                    modelItem.remove();
                }
                event.preventDefault();
            });

            modelElem.append(modelItem);
        };
        var parentForm = this.field.parents("form");
        this.field.parent().append(this.newField);
        this.field.removeAttr("data-validation-optional").removeAttr("data-each-validation-length").removeAttr("maxlength");

        if (parentForm.length > 0) {
            parentForm.submit(function (event) {
                var text = that.newField.val();
                if (that.newField.valid()) {
                    that.appendFieldValue(text);
                }
            });
        }

        this.newField.keydown(function (event) {
            if (event.which == 13) {
                if (!that.hasAutoComplete) {
                    var text = $(this).val();
                    if ($(this).valid()) {
                        $(this).val("");
                        that.appendFieldValue(text);
                    }
                    else {
                        if (text == "") {
                            var errors = { "Errors": {} };
                            errors.Errors[$(this).attr("id")] = [L.Global.ErrorMessages.TagEmpty()];
                            Cobalt.Forms.displayErrors(parentForm, errors.Errors);
                        }
                    }
                }
                event.preventDefault();
            }
        });

        this.addCurrentModels();
        this.field.hide();
        this.autoCompleteMenu = this.newField.autocomplete(this.field.attr("data-autocomplete-url"), {
            minChars: 3,
            scroll: false,
            dataType: 'json',
            selectFirst: false,
            parse: function (data) {
                var rows = new Array();
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        rows[i] = { data: data[i], value: data[i].Value, result: data[i].Key };
                    }
                }
                return rows;
            },
            highlight: function (value, searchTerm) {
                that.hasAutoComplete = true;
                return value.replace(searchTerm, "<strong>" + searchTerm + "</strong>");
            },
            formatItem: function (row) {
                var resultDiv = $("<div>").html(row.Display || row.Key);

                return resultDiv.html();
            },
            resultsClass: 'modal tag-autocomplete ac_results'
        }).result(function (evt, data, formatted) {
            that.appendFieldValue(data.Display || data.Key, data.Value);
        }).hideResults(function () {
            that.hasAutoComplete = false;
        });
    };

    Cobalt.ModelMultipleSymbolicField = {
        initialize: function () {

            Cobalt.runOnHtmlInsert(function () {
                var fields = $(".j-model-multiple-symbolic-field");

                fields.each(function () {
                    var field = $(this);
                    if (field.data("CobaltModelMultiSymbolFieldInit") != null) { // Ensures that the system does not initialize more than once per form field element.
                        return;
                    }
                    field.data("CobaltTagInitCobaltModelMultiSymbolFieldInit", true)
                    $.extend(field, new Cobalt.ModelMultiSymbolField(field));
                });
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ModelMultipleSymbolicField.js